<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!LabId">Adding Lab</span>
                <span *ngIf="LabId">Update Lab</span>
            </h1>
        </div>
        <mat-tab-group mat-align-tabs="start" [selectedIndex]=activeTab>
            <mat-tab label="Basic Info">
                <div class="card">
                    <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-8 border-right">
                            <form [formGroup]="labForm" (submit)="createLab()">
                                <div class="card-body">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Name *</label>
                                                    <input type="text" formControlName="name"
                                                        class="form-control" />
                                                    <div *ngIf="submitted && f.name.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.name.errors.required">Name is required</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Mobile *</label>
                                                    <input type="text" formControlName="mobile"
                                                        class="form-control" />
                                                    <div *ngIf="submitted && f.mobile.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.mobile.errors.required">Mobile is required
                                                        </div>
                                                        <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid
                                                            Mobile number format</div>
                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Email *</label>
                                                    <input type="text" formControlName="email"
                                                        class="form-control" />
                                                    <div *ngIf="submitted && f.email.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.email.errors.required">Email is required</div>
                                                        <div *ngIf="!f.email.valid && f.email.value">Email format is
                                                            Invalid</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-6">
                                                <label class="form-label">Status *</label>
                                                <mat-select placeholder="Status" formControlName="status">
                                                    <mat-option [value]="1">Active</mat-option>
                                                    <mat-option [value]="0">In-Active</mat-option>

                                                </mat-select>
                                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                                    <div *ngIf="f.status.errors.required">Status is required</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Circle *</label>
                                                    <mat-select (selectionChange)="getCircleCities($event.value)"
                                                        placeholder="Circle" formControlName="circle_id"
                                                        (click)="setSearchValue('circle')">
                                                        <input class="mySearchInput" #circleSearch focused="'true'"
                                                            type="text"
                                                            (keyup)="searchOnSelect($event.target.value, 'circle')"
                                                            (keydown)="$event.stopPropagation()" autocomplete="off"
                                                            placeholder="Search" id="circleSearch">
                                                        <mat-option>All</mat-option>
                                                        <mat-option [value]="cir.id" *ngFor="let cir of circles">
                                                            {{cir.name}}</mat-option>
                                                    </mat-select>
                                                    <div *ngIf="submitted && f.circle_id.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.circle_id.errors.required">Circle is required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">City *</label>
                                                    <mat-select placeholder="City" [disabled]="lab_city"
                                                        formControlName="city_id" (click)="setSearchValue('city')">
                                                        <input class="mySearchInput" #citySearch focused="'true'"
                                                            type="text"
                                                            (keyup)="searchOnSelect($event.target.value, 'cities')"
                                                            (keydown)="$event.stopPropagation()" autocomplete="off"
                                                            placeholder="Search" id="citySearch">
                                                        <mat-option [value]="cir.id" *ngFor="let cir of cities">
                                                            {{cir.name}}</mat-option>
                                                    </mat-select>
                                                    <div *ngIf="submitted && f.city_id.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.city_id.errors.required">City is required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="form-label">Address *</label>
                                                    <textarea class="form-control"
                                                        formControlName="address"></textarea>
                                                    <div *ngIf="submitted && f.address.errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.address.errors.required">Address is required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                                            class="fa fa-spin fa-spinner"></i>
                                        <span *ngIf="!LabId">Create Lab</span>
                                        <span *ngIf="LabId">Update Lab</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="col-sm-4 mt-5" *ngIf="LabId>0">
                            <h2>Upload Lab Documents</h2>
                            <div class="form-group">
                                <label>Select Document Type</label>
                                <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                                    <mat-option value="">Select Document Type</mat-option>
                                    <mat-option [value]="1">Lab Agreement</mat-option>
                                </mat-select>
                            </div>
                            <div class="form-group">
                                <label>Upload Documents</label>
                                <input [disabled]="uploading" type="file" (change)="selectFile($event)" class="form-control" />
                                <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                            </div>
                            <div class="list-group list-group-flush list-group-hoverable">
                                <p *ngIf="fileDeleting"><i class="fa fa-spin fa-spinner"></i> deleting file...</p>
                                <div class="list-group-item" *ngFor="let upload of allUploads">
                                    <div class="row align-items-center">
                                        <div class="col text-truncate">
                                            <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                                            <a *ngIf="myrole=='1'" class="delete-file text-danger" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                            [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                                            confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                            [appendToBody]="true"><i class="fa fa-trash"></i></a>
                                            &nbsp;&nbsp;
                                            <span class="badge badge-success" *ngIf='upload.upload_type==1'> Lab Agreement</span>
                                            <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

    </div>
</div>